import { render, staticRenderFns } from "./ListenerGenreDetails.vue?vue&type=template&id=0f821ea8&scoped=true"
import script from "./ListenerGenreDetails.vue?vue&type=script&lang=js"
export * from "./ListenerGenreDetails.vue?vue&type=script&lang=js"
import style0 from "./ListenerGenreDetails.vue?vue&type=style&index=0&id=0f821ea8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f821ea8",
  null
  
)

export default component.exports